import { FileBase64Response } from "../../../../model/base/response/file-base-64-response";
import { IOfficialDiaryDetailResponse } from "../../../../model/official-daily/response/official-diary-detail-response";


export type DetalhesDiarioOficialState = {
    officialDiaryDetailResponse: IOfficialDiaryDetailResponse;
};

export enum ACTION_TYPES {
    setOfficialDiaryDetailResponse = 'setOfficialDiaryDetailResponse',

}

export const DetalhesDiarioOficialReducer = (state: DetalhesDiarioOficialState, action: any): DetalhesDiarioOficialState => {
    const { type, payload } = action;
    switch (type) {
        case ACTION_TYPES.setOfficialDiaryDetailResponse:
            return {
                ...state,
                officialDiaryDetailResponse: payload,
            };


        default:
            throw new Error(`Unhandled action type: ${type}`);
    }
}